"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Product_1 = require("../../../classes/Product");
var Student_1 = require("../../../classes/Student");
var Coupon_1 = require("../../../classes/Coupon");
var Cashier_1 = require("../../../classes/Cashier");
var Order_1 = require("../../../classes/Order");
var BillingGateway_1 = require("../../../classes/billing/BillingGateway");
var PaymentRequest_1 = require("../../../common/payments/PaymentRequest");
var InstructorCreateOrderController = /** @class */ (function () {
    function InstructorCreateOrderController($scope, $state, ProductsModel, CouponsModel, OrdersModel, FlashService, UsersModel, CreateOrderService, CustomerSourceModel, Stripe3DSService) {
        var _this = this;
        /** The order form only builds the order; this screen sends it and sees the answer, so it holds the key. */
        this.newOrder = new PaymentRequest_1.PaymentRequest();
        this.$scope = $scope;
        this.Stripe3DSService = Stripe3DSService;
        this.CreateOrderService = CreateOrderService;
        this.$state = $state;
        this.FlashService = FlashService;
        this.OrdersModel = OrdersModel;
        this.CouponsModel = CouponsModel;
        this.UsersModel = UsersModel;
        this.product = null;
        this.student = null;
        this.products = [];
        this.coupons = [];
        this.submitting = false;
        this.customerSource = null;
        this.couponConfig = {
            loading: true,
            coupon: {
                code: "",
                max_redemptions: null,
                description: "",
                type: "",
                amount: null,
                start: null,
                end: null,
            },
            showNewCouponForm: false,
        };
        this.handleCouponStartDateChange =
            this.handleCouponStartDateChange.bind(this);
        this.handleCouponEndDateChange = this.handleCouponEndDateChange.bind(this);
        this.createOrder = this.createOrder.bind(this);
        this.handlePaypalOrderComplete = this.handlePaypalOrderComplete.bind(this);
        this.$cashier = CreateOrderService.cashier();
        var order = new Order_1.Order();
        this.$cashier.setOrder(order);
        this.$order = this.$cashier.$order;
        this.marketingOptions = [];
        ProductsModel.get({ paging: false, disabled: 0 }).then(function (response) {
            _this.products = response.products.data.map(function (product) { return new Product_1.Product(product); });
            _this.loading = false;
        });
        CustomerSourceModel.getCustomerSources().then(function (response) {
            _this.marketingOptions = response.customer_sources;
        });
        CouponsModel.get({ paging: false, valid: true }).then(function (response) {
            _this.coupons = response.coupons.map(function (coupon) { return new Coupon_1.Coupon(coupon); });
            _this.couponConfig.loading = false;
        });
        this.createOrder = this.createOrder.bind(this);
        $scope.$watch(function () { return _this.student; }, function (newVal) {
            if (!_this.student) {
                return;
            }
            _this.$cashier.addStudent(new Student_1.Student(_this.student));
            CreateOrderService.updateBillingAddressesList();
            CreateOrderService.updatePaymentMethodsList();
        });
    }
    InstructorCreateOrderController.prototype.handleCouponStartDateChange = function (datetime) {
        if (datetime.selected.length === 0) {
            this.couponConfig.coupon.start = null;
        }
        else {
            this.couponConfig.coupon.start = datetime.selected[0];
        }
    };
    InstructorCreateOrderController.prototype.handleCouponEndDateChange = function (datetime) {
        if (datetime.selected.length === 0) {
            this.couponConfig.coupon.end = null;
        }
        else {
            this.couponConfig.coupon.end = datetime.selected[0];
        }
    };
    InstructorCreateOrderController.prototype.createCoupon = function () {
        var _this = this;
        this.couponConfig.loading = true;
        var coupon = Object.assign({}, this.couponConfig.coupon);
        if (coupon.type === "fixed") {
            coupon.amount = coupon.amount * 100;
        }
        this.CouponsModel.create(coupon).then(function (response) {
            _this.couponConfig.loading = false;
            var newCoupon = new Coupon_1.Coupon(response.coupon);
            _this.coupons.push(newCoupon);
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.couponConfig.coupon = {
                code: "",
                max_redemptions: null,
                description: "",
                type: "",
                amount: null,
                start: null,
                end: null,
            };
            _this.addCouponToOrder(newCoupon);
        });
    };
    InstructorCreateOrderController.prototype.reset = function () {
        this.loading = false;
        this.submitting = false;
    };
    InstructorCreateOrderController.prototype.createOrder = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, threeDSResult, confirmResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitting = true;
                        order.submitted = true;
                        data = (0, Cashier_1.cashierOrderRequestTransformer)(this.$cashier);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        return [4 /*yield*/, this.OrdersModel.create(this.newOrder.bodyFor((0, PaymentRequest_1.orderWithoutOneTimeTokens)(data), function (requestId) { return (__assign(__assign({}, data), { request_id: requestId })); }))];
                    case 2:
                        response = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.answered(response));
                        if (!this.Stripe3DSService.isThreeDSecureRequired(response)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Stripe3DSService.handle3DSChallenge(response.client_secret, this.stripePublishableKey())];
                    case 3:
                        threeDSResult = _a.sent();
                        if (!threeDSResult.success) {
                            this.newOrder.settled(PaymentRequest_1.PaymentOutcome.challengeFailed(threeDSResult));
                            this.FlashService.setMessage({
                                type: "error",
                                message: threeDSResult.error ||
                                    "Payment authentication failed. Please try again.",
                            });
                            order.submitted = false;
                            this.reset();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Stripe3DSService.confirmOrderPayment(response.order_id, response.payment_intent_id, {
                                student_id: this.$cashier.order().student().id(),
                                amount: response.amount,
                            })];
                    case 4:
                        confirmResponse = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.answered(confirmResponse));
                        this.FlashService.setMessage({
                            type: "success",
                            message: confirmResponse.message,
                        });
                        this.$state.go("drivecoach.instructor.dashboard");
                        this.reset();
                        return [2 /*return*/, confirmResponse];
                    case 5:
                        this.FlashService.setMessage({
                            type: "success",
                            message: response.message,
                        });
                        this.$state.go("drivecoach.instructor.dashboard");
                        this.reset();
                        return [2 /*return*/, response];
                    case 6:
                        error_1 = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        order.submitted = false;
                        return [3 /*break*/, 8];
                    case 7:
                        // Awaited native promises run outside AngularJS's digest.
                        this.$scope.$applyAsync();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /** Only a Stripe school's card answers 202 requires_action. */
    InstructorCreateOrderController.prototype.stripePublishableKey = function () {
        return (0, BillingGateway_1.createBillingGatewayFromPolicies)(this.$cashier.policies()).config()
            .stripe_publishable_key;
    };
    InstructorCreateOrderController.prototype.addProductToOrder = function () {
        this.$cashier.addProduct(this.product);
        // set initial value for "amount paid today" field
        this.updatePaymentAmountInput();
        this.$cashier.calculateTotal();
    };
    /**
     * Make the payment amount input match the total due (surcharges not applied)
     */
    InstructorCreateOrderController.prototype.updatePaymentAmountInput = function () {
        this.$cashier.order().payments()[0].setAmount(this.$cashier.totalDue());
    };
    InstructorCreateOrderController.prototype.addCouponToOrder = function (coupon) {
        this.$cashier.addCoupon(coupon);
        this.$cashier.calculateTotal();
        this.updatePaymentAmountInput();
    };
    /**
     * Handle PayPal order completion.
     * For PayPal, the order is already created and payment is already captured
     * by the PayPal component. We just need to show success and navigate.
     */
    InstructorCreateOrderController.prototype.handlePaypalOrderComplete = function (orderId, studentId) {
        this.FlashService.setMessage({
            type: "success",
            message: "Order completed successfully.",
        });
        this.$state.go("drivecoach.instructor.dashboard");
        this.reset();
    };
    return InstructorCreateOrderController;
}());
InstructorCreateOrderController.$inject = [
    "$scope",
    "$state",
    "ProductsModel",
    "CouponsModel",
    "OrdersModel",
    "FlashService",
    "UsersModel",
    "CreateOrderService",
    "CustomerSourceModel",
    "Stripe3DSService",
];
exports.default = InstructorCreateOrderController;
